export enum SupervisorType {
    SET_SETTINGS = "SET_SETTINGS",

}